import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectUser, selectPermissions, selectIsAuthenticated, getCurrentUser } from '@store/slices/authSlice';
import { fetchPermissions } from '@store/slices/authSlice';
import authService from '@services/auth.service';

const PermissionsInitializer = ({ children }) => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const permissions = useSelector(selectPermissions);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Prevent multiple initializations
    if (hasInitialized.current) {
      return;
    }

    const initialize = async () => {
      const token = authService.getAccessToken();
      
      // If we have a token and are authenticated but no user data, fetch it
      if (token && isAuthenticated && !user) {
        console.log('PermissionsInitializer: Token exists but no user data, fetching from backend');
        try {
          await dispatch(getCurrentUser()).unwrap();
        } catch (error) {
          console.error('PermissionsInitializer: Failed to fetch current user', error);
        }
      }
      
      // Fetch permissions for authenticated admin users
      if (isAuthenticated && user?.role === 'admin' && (!permissions || permissions.length === 0)) {
        console.log('PermissionsInitializer: Fetching permissions for admin user');
        dispatch(fetchPermissions()).catch(error => {
          console.error('PermissionsInitializer: Failed to fetch permissions', error);
        });
      }
      
      hasInitialized.current = true;
    };

    initialize();
  }, [isAuthenticated, user, permissions, dispatch]);

  // Always render children - this component should not block rendering
  return children;
};

export default PermissionsInitializer;
